import React, { useState } from "react";
import styles from "./profile-box.module.css";
import EmojiSelector from "../../features/emojis/components/EmojiSelector";

interface EmojiInputProps {
  /** Called with the claimed emoji after a successful, permanent claim. */
  onEmojiSubmit: (emoji: string) => void;
}

/**
 * Profile "claim your signature emoji" entry point. Opens the shared
 * <EmojiSelector> in claim mode, which reads the curated registry and writes
 * through POST /api/emoji/claim (permanent, unique, immutable).
 */
const EmojiInput: React.FC<EmojiInputProps> = ({ onEmojiSubmit }) => {
  const [open, setOpen] = useState(false);

  if (!open) {
    return (
      <div className={styles.emojiInputGroup}>
        <button className={styles.addEmojiButton} onClick={() => setOpen(true)}>
          Choose your emoji
        </button>
      </div>
    );
  }

  return (
    <div className={styles.emojiInputGroup}>
      <EmojiSelector
        mode="claim"
        onClaimed={(emoji) => {
          onEmojiSubmit(emoji);
          setOpen(false);
        }}
      />
      <button className={styles.cancelButton} onClick={() => setOpen(false)}>
        Close
      </button>
    </div>
  );
};

export default EmojiInput;
